module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./iconfont.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/iconfont.md
// module id = 3pvG
// module chunks = 0